import { useMutation } from '@tanstack/react-query';

import type { UpdatePasswordPayload } from './types';

import { request } from '../request';

export const useUpdatePassword = () => {
  return useMutation({
    mutationFn: (body: UpdatePasswordPayload) => {
      return request('/user', { method: 'POST', body });
    },
  });
};
